import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { AwldsUiLibAngularModule } from '@alightengineering/awlds-ui-lib-angular';
import { DialogComponent } from 'src/app/components/common/dialog/dialog.component';
import { CustomDialogComponent } from 'src/app/components/common/custom-dialog/custom-dialog.component';
import { CustomerAccountDialogComponent } from 'src/app/components/common/customer-account-dialog/customer-account-dialog.component';
import { CardLoaderComponent } from 'src/app/components/common/card-loader/card-loader.component';
import { LoaderComponent } from 'src/app/components/common/loader/loader.component';
import { SortByPipe } from 'src/app/pipes/sort-by.pipe';
import { SafePipe } from 'src/app/pipes/decimal.pipe';
import { AutocompleteOffDirective } from 'src/app/directives/auto-focus.directive';
import { CarouselComponent } from 'src/app/components/common/carousel/carousel.component';
import { DynamicContentComponent } from 'src/app/components/common/dynamic-content/dynamic-content.component';

@NgModule({
  declarations: [
    DialogComponent,
    CustomDialogComponent,
    CardLoaderComponent,
    CustomerAccountDialogComponent,
    LoaderComponent,SortByPipe,SafePipe,AutocompleteOffDirective,CarouselComponent,DynamicContentComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AwldsUiLibAngularModule,
    MaterialModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AwldsUiLibAngularModule,
    MaterialModule,
    CustomDialogComponent,
    CardLoaderComponent,
    CustomerAccountDialogComponent,
    LoaderComponent,SortByPipe,SafePipe,AutocompleteOffDirective,CarouselComponent,DynamicContentComponent
  ],
})
export class SharedModule {}
